module.exports = __webpack_public_path__ + "img/2.25bd9dc8.png";